<template>
  <div class="image-cover-wrap" v-if="imageModel.HasCrop">
    <picture>
      <source :data-srcset="imageModel.SrcSetWebP" type="image/webp" data-sizes="auto" />
      <source :data-srcset="imageModel.SrcSet" :type="imageModel.Type" data-sizes="auto" />
      <img :src="imageModel.Src" :data-src="imageModel.DataSrc" class="image-cover lazyload" :alt="imageModel.AltText"
        data-sizes="auto" :style="imageModel.Style" />
    </picture>
  </div>
  <img v-if="!imageModel.HasCrop" :src="imageModel.Src" :data-src="imageModel.DataSrc" class="image-cover lazyload"
    :alt="imageModel.AltText" :style="imageModel.Style" />
</template>

<script>
export default {
  name: "responsiveImage",
  props: ["imageModel"],
};
</script>